export const FDS_SUCCESS_SUB_PATH = 'apply'

export const FDS_CANCELED_SUB_PATH = 'cancel'
